export default "__VITE_ASSET__BvBxTdTE__"